import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

function ListadoPendEmbarcar() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  // const URL_INVENTARIOS = `${process.env.REACT_APP_URL_INVENTARIOS}DesarrolloPendEmbarcar`;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_OC_PEND_EMBARCAR = process.env.REACT_APP_URL_ARTICULOS_OC_PEND_EMBARCAR;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_ARTICULOS_OC_ACUMULADOS = process.env.REACT_APP_URL_ARTICULOS_OC_ACUMULADOS;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;


  const [articulosOC, setArticulosOC] = useState([]);

  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");

  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [lineas, setLineas] = useState([]);
  const [selectedLineaFiltro, setSelectedLineaFiltro] = useState("");
  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");
  const [familias, setFamilias] = useState([]);
  const [selectedFamiliaFiltro, setSelectedFamiliaFiltro] = useState("");
  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState("");

  const [totalPedido, setTotalPedido] = useState("");
  const [totalPendiente, setTotalPendiente] = useState("");
  const [totalEmb, setTotalEmb] = useState("");

  const [cargando, setCargando] = useState(true);

  // const [fechasCompromiso, setFechasCompromiso] = useState([]);
  // const [codigoFecha, setCodigoFecha] = useState("");
  // const [nombreFecha, setNombreFecha] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalMailRollo, setModalMailRollo] = useState(false);
  const toggleMailRollo = () => setModalMailRollo(!modalMailRollo);

  const [modalDesgloce, setModalDesgloce] = useState(false);
  const toggleDesgloce = () => setModalDesgloce(!modalDesgloce);
  const [desgloceOC, setDesgloceOC] = useState([]);
  const [desgloceArticulo, setDesgloceArticulo] = useState("");
  const [desgloceTotal, setDesgloceTotal] = useState(0);

  // const [modalFechasCompromiso, setModalFechasCompromiso] = useState(false);
  // const toggleFechasCompromiso = () =>
  //   setModalFechasCompromiso(!modalFechasCompromiso);

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(12), (val, index) => index + year);
  
  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
  }

  useEffect(() => {
    axios
      .get(`${URL_ARTICULOS_OC_ACUMULADOS}/PendEmbarcar`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPendEmbarcar = response.data;
        setComments(allPendEmbarcar);
        setCargando(false);
        Toast.close();
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(`${URL_PROVEEDORES}Tipo/China`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allLineas = response.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allMarcas = response.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_FAMILIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allFamilias = response.data;
        setFamilias(allFamilias);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_UNIDADES_NEGOCIO, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allUnidadesNegocio = response.data;
        setUnidadesNegocio(allUnidadesNegocio);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function PDFTabla() {
    let total_cantidad = 0;
    let total_embarcado = 0;
    let total_pendiente_embarcar = 0;

    const data = comments
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {
        if (
          (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
          (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
          (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) &&
          (selectedFamiliaFiltro == 0 ||
            selectedFamiliaFiltro == a.idFamilia) &&
          (selectedUnidadNegocio == 0 || selectedUnidadNegocio == a.idUnidadNegocio) &&
          (activo == 0 || activo == a.is_active)
        ) {
          // total_cantidad = parseFloat(total_cantidad) + parseFloat(a.cantidad);
          // total_embarcado =
          //   parseFloat(total_embarcado) + parseFloat(a.embarcado);
          total_pendiente_embarcar =
            parseFloat(total_pendiente_embarcar) +
            parseFloat(a.pendiente_embarcar);
          return [
            a.codigo,
            a.nombre,
            a.proveedor,
            a.linea,
            a.marca,
            a.familia,
            a.unidadNegocio,
            // new Intl.NumberFormat("en-US").format(a.cantidad),
            // new Intl.NumberFormat("en-US").format(a.embarcado),
            new Intl.NumberFormat("en-US").format(a.pendiente_embarcar),
          ];
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 40, 30);
    doc.text(`Listado Pendiente Embarcar`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Nombre",
          "Proveedor",
          "Linea",
          "Marca",
          "Familia",
          "UnidadNegocio",
          // "Pedido Acumulado",
          // "Embarcado Acumulado",
          "Pend. Embarcar",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "Total",
          // new Intl.NumberFormat("en-US").format(total_cantidad),
          // new Intl.NumberFormat("en-US").format(total_embarcado),
          new Intl.NumberFormat("en-US").format(total_pendiente_embarcar),
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save(`PendEmbarcar.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
        (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
        (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        (selectedFamiliaFiltro == 0 ||
          selectedFamiliaFiltro == a.idFamilia) &&
        (selectedUnidadNegocio == 0 || selectedUnidadNegocio == a.idUnidadNegocio) &&
        (activo == 0 || activo == a.is_active)
      ) {
        return {
          Codigo: a.codigo,
          Nombre: a.nombre,
          Proveedor: a.proveedor,
          Linea: a.linea,
          Marca: a.marca,
          Familia: a.familia,
          UnidadNegocio: a.unidadNegocio,
          // PedidoAcumulado: a.cantidad,
          // EmbarcadoAcumulado: a.embarcado,
          PendEmbarcar: a.pendiente_embarcar,
          // id: a._id,
          // idArticulo: a.idArticulo,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoPendEmbarcar";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoPendEmbarcar",
        sheetFilter: [
          "Codigo",
          "Nombre",
          "Proveedor",
          "Linea",
          "Marca",
          "Familia",
          "UnidadNegocio",
          // "PedidoAcumulado",
          // "EmbarcadoAcumulado",
          "PendEmbarcar",
          // "id",
          // "idArticulo",
        ],
        sheetHeader: [
          "Codigo",
          "Nombre",
          "Proveedor",
          "Linea",
          "Marca",
          "Familia",
          "UnidadNegocio",
          // "PedidoAcumulado",
          // "EmbarcadoAcumulado",
          "PendEmbarcar",
          // "id",
          // "idArticulo",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let total_cantidad = 0;
    let total_embarcado = 0;
    let total_pendiente_embarcar = 0;

    const data = comments
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {
        if (
          (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
          (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
          (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) &&
          (selectedFamiliaFiltro == 0 ||
            selectedFamiliaFiltro == a.idFamilia) &&
          (selectedUnidadNegocio == 0 || selectedUnidadNegocio == a.idUnidadNegocio) &&
          (activo == 0 || activo == a.is_active)
        ) {
          // total_cantidad = parseFloat(total_cantidad) + parseFloat(a.cantidad);
          // total_embarcado =
          //   parseFloat(total_embarcado) + parseFloat(a.embarcado);
          total_pendiente_embarcar =
            parseFloat(total_pendiente_embarcar) +
            parseFloat(a.pendiente_embarcar);
          return [
            a.codigo,
            a.nombre,
            a.proveedor,
            a.linea,
            a.marca,
            a.familia,
            a.unidadNegocio,
            // new Intl.NumberFormat("en-US").format(a.cantidad),
            // new Intl.NumberFormat("en-US").format(a.embarcado),
            new Intl.NumberFormat("en-US").format(a.pendiente_embarcar),
          ];
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 40, 30);
    doc.text(`Listado Pendiente Embarcar`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Nombre",
          "Proveedor",
          "Linea",
          "Marca",
          "Familia",
          "UnidadNegocio",
          // "PedidoAcumulado",
          // "EmbarcadoAcumulado",
          "Pend. Embarcar",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "Total",
          // new Intl.NumberFormat("en-US").format(total_cantidad),
          // new Intl.NumberFormat("en-US").format(total_embarcado),
          new Intl.NumberFormat("en-US").format(total_pendiente_embarcar),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado PendEmbarcar",
          email: mailTo,
          fileName: "ListadoPendEmbarcar.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de PendEmbarcars.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Proveedor", field: "proveedor", sortable: true },
    // { name: "Fecha OC", field: "fechaOC", sortable: true },
    // { name: "Fecha Compromiso", field: "fechaCompromiso", sortable: true },
    { name: "Linea", field: "linea", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    { name: "Familia", field: "familia", sortable: true },
    { name: "UnidadNegocio", field: "unidadNegocio", sortable: true },
    // { name: "Pedido Acumulado", field: "cantidad", sortable: true },
    // { name: "Embarcado Acumulado", field: "embarcado", sortable: true },
    { name: "Pend Embarcar", field: "pendiente_embarcar", sortable: true },
    { name: "Desglose", field: "desglose", sortable: false },
    // { name: "Compromiso", field: "fecha", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.codigo.toLowerCase().includes(search.toLowerCase()) ||
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.proveedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.linea.toLowerCase().includes(search.toLowerCase()) ||
          comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          comment.familia.toLowerCase().includes(search.toLowerCase()) ||
          comment.unidadNegocio.toLowerCase().includes(search.toLowerCase()) ||
          // comment.cantidad.toString().includes(search) ||
          // comment.embarcado.toString().includes(search) ||
          comment.pendiente_embarcar.toString().includes(search)
      );
    }
    if (selectedLineaFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idLinea.includes(selectedLineaFiltro)
      );
    }
    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        e.idMarca.includes(selectedMarca)
      );
    }
    if (selectedArticulo) {
      computedComments = computedComments.filter((e) =>
        e.idArticulo.includes(selectedArticulo)
      );
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedor.includes(selectedProveedor)
      );
    }
    if (selectedFamiliaFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idFamilia.includes(selectedFamiliaFiltro)
      );
    }
    if (selectedUnidadNegocio) {
      computedComments = computedComments.filter((e) =>
        e.idUnidadNegocio.includes(selectedUnidadNegocio)
      );
    }

    setTotalItems(computedComments.length);

    // let ped = computedComments.map((c) => parseFloat(c.cantidad));
    // let Tped = ped.reduce((t, cantidad, index) => t + cantidad, 0);
    // setTotalPedido(Tped);

    // let emb = computedComments.map((c) => parseFloat(c.embarcado));
    // let Temb = emb.reduce((t, embarcado, index) => t + embarcado, 0);
    // setTotalEmb(Temb);

    let pen = computedComments.map((c) => parseFloat(c.pendiente_embarcar));
    let Tpen = pen.reduce((t, pendiente_embarcar, index) => t + pendiente_embarcar, 0);
    setTotalPendiente(Tpen);

    //Sorting comments
    if (
      sorting.field &&
      // sorting.field != "cantidad" &&
      // sorting.field != "embarcado" &&
      sorting.field != "pendiente_embarcar"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (
        // sorting.field == "cantidad" ||
        // sorting.field == "embarcado" ||
        sorting.field == "pendiente_embarcar")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (
        // sorting.field == "cantidad" ||
        // sorting.field == "embarcado" ||
        sorting.field == "pendiente_embarcar")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedArticulo,
    selectedProveedor,
    selectedLineaFiltro,
    selectedMarca,
    selectedFamiliaFiltro,
    selectedUnidadNegocio,
  ]);

  function limpiarSearch() {
    setSearch("");
    setSelectedArticulo("");
    setSelectedProveedor("");
    setSelectedLineaFiltro("");
    setSelectedMarca("");
    setSelectedFamiliaFiltro("");
    setSelectedUnidadNegocio("");
  }

  function jalaDesgloce(idArticulo, codigo, nombre) {
    setDesgloceArticulo(`${codigo} - ${nombre}`);
    axios
      .get(`${URL_ARTICULOS_OC}/PendEmbarcarArticulo/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        const data = response.data || [];
        setDesgloceOC(data);
        const total = data.reduce(
          (t, a) => t + parseFloat(a.pendiente_embarcar || 0),
          0
        );
        setDesgloceTotal(total);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleDesgloce();
  }

  // function jalaFechasCompromiso(idArticulo, codigo, nombre) {
  //   setCodigoFecha(codigo);
  //   setNombreFecha(nombre);
  //   axios
  //     .get(`${URL_ARTICULOS_OC}/PendEmbarcarArticulo/${idArticulo}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allfechasCompromiso = response.data;
  //       setFechasCompromiso(allfechasCompromiso);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  //   toggleFechasCompromiso();
  // }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pendiente_embarcar ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Pendiente Embarcar</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          <h3 align="center">Pendiente Embarcar</h3>
          <div className="row">
            <div className="col-md-10">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-1 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
            <div className="col-md-1 flex-row-reverse">
              <Button
                size="sm"
                className="btn"
                color="info"
                onClick={limpiarSearch}
              >
                Limpiar
              </Button>
            </div>
          </div>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArticulo}
                  onChange={(e) => {
                    setSelectedArticulo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {articulos
                    .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.SKU}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArticulo}
                  onChange={(e) => {
                    setSelectedArticulo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {articulos
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.nombre}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedProveedor}
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.nombre_comercial}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedLineaFiltro}
                  onChange={(e) => {
                    setSelectedLineaFiltro(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {lineas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMarca}
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a > b ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>

              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedFamiliaFiltro}
                  onChange={(e) => {
                    setSelectedFamiliaFiltro(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {familias
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedUnidadNegocio}
                  onChange={(e) => {
                    setSelectedUnidadNegocio(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {unidadesNegocio
                    .sort((a, b) => (a > b ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
            </tr>
            <tbody>
              {commentsData
              .map((a) => {
                {
                  return (
                    <tr>
                      <td>{a.codigo}</td>
                      <td>{a.nombre}</td>
                      <td>{a.proveedor}</td>
                      {/* <td>{a.fechaOC}</td>
                      <td>{a.fechaCompromiso}</td> */}
                      <td>{a.linea}</td>
                      <td>{a.marca}</td>
                      <td>{a.familia}</td>
                      <td>{a.unidadNegocio}</td>
                      {/* <td>
                        {new Intl.NumberFormat("en-US").format(a.cantidad)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.embarcado)}
                      </td> */}
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.pendiente_embarcar
                        )}
                      </td>
                      <td>
                        <Button
                          size="sm"
                          className="btn"
                          color="info"
                          onClick={(e) =>
                            jalaDesgloce(a.idArticulo, a.codigo, a.nombre)
                          }
                          title="Ver en qué órdenes de compra están las piezas pendientes"
                        >
                          <i class="fas fa-list-ul"></i>
                        </Button>
                      </td>
                      {/* <td>
                        <Button
                          size="sm"
                          className="btn"
                          color="info"
                          onClick={(e) =>
                            jalaFechasCompromiso(
                              a.idArticulo,
                              a.codigo,
                              a.nombre,
                              a.cantidad,
                              a.contenedor
                            )
                          }
                        >
                          <i class="far fa-calendar-alt"></i>
                        </Button>
                      </td> */}
                    </tr>
                  );
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                {/* <td></td>
                <td></td> */}
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                {/* <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalPedido)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalEmb)}
                </td> */}
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalPendiente)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}

      {/* <Modal
        size="xl"
        isOpen={modalFechasCompromiso}
        toggle={toggleFechasCompromiso}
      >
        <ModalHeader toggle={toggleFechasCompromiso}>
          <h4>Fechas Compromiso de Entrega</h4>
          <h4>
            Codigo: {codigoFecha}, Articulo: {nombreFecha}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Table size="sm" striped bordered className="table-responsive-xl">
            <tr>
              <th>Orden de Compra</th>
              <th>Cantidad en OC</th>
              <th>Embarcado</th>
              <th>Pendiente Embarcar</th>
              <th>Fecha Compromiso</th>
            </tr>
            <tbody>
              {fechasCompromiso.map((a) => {
                return (
                  <tr>
                    <td align="center">{a.idOrdenCompra}</td>
                    <td align="center">
                      {new Intl.NumberFormat("en-US").format(a.cantidad)}
                    </td>
                    <td align="center">
                      {new Intl.NumberFormat("en-US").format(a.embarcado)}
                    </td>
                    <td align="center">
                      {new Intl.NumberFormat("en-US").format(
                        a.pendiente_embarcar
                      )}
                    </td>
                    <td align="center">{a.fecha_compromiso}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </Modal> */}

      <Modal size="lg" isOpen={modalDesgloce} toggle={toggleDesgloce}>
        <ModalHeader toggle={toggleDesgloce}>
          <h4>Desglose por OC — {desgloceArticulo}</h4>
        </ModalHeader>
        <ModalBody>
          <Table size="sm" striped borderless>
            <thead>
              <tr>
                <th>OC #</th>
                <th>Fecha OC</th>
                <th>Proveedor</th>
                <th className="text-right">Pedido</th>
                <th className="text-right">Embarcado</th>
                <th className="text-right">Pend. Embarcar</th>
              </tr>
            </thead>
            <tbody>
              {desgloceOC.map((a, i) => (
                <tr key={i}>
                  <td>{a.idOrdenCompra}</td>
                  <td>{a.fechaOC}</td>
                  <td>{a.proveedor}</td>
                  <td className="text-right">
                    {new Intl.NumberFormat("en-US").format(a.cantidad)}
                  </td>
                  <td className="text-right">
                    {new Intl.NumberFormat("en-US").format(a.embarcado)}
                  </td>
                  <td className="text-right">
                    {new Intl.NumberFormat("en-US").format(a.pendiente_embarcar)}
                  </td>
                </tr>
              ))}
              <tr>
                <td className="negrita" colSpan={5}>
                  TOTAL
                </td>
                <td className="negrita text-right">
                  {new Intl.NumberFormat("en-US").format(desgloceTotal)}
                </td>
              </tr>
            </tbody>
          </Table>
          {desgloceOC.length === 0 ? (
            <p align="center">Sin órdenes de compra pendientes por embarcar.</p>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggleDesgloce}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoPendEmbarcar;
